import { HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export function handle500Interceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);
  return next(req).pipe(
    catchError(
      (err: HttpErrorResponse): Observable<HttpEvent<unknown>> =>
        from(import('./500.handler')).pipe(
          switchMap(
            (m: {
              handle500InterceptorError: (
                request: HttpRequest<unknown>,
                err: HttpErrorResponse,
                injector: Injector
              ) => Observable<HttpEvent<unknown>>;
            }) => m.handle500InterceptorError(req, err, injector)
          )
        )
    )
  );
}
